import { DsiAdditionalClassificationsTracking } from './dsiAdditionalClassifications';
import { DsiInspectionConfirmationResult, DsiInspectionResult } from './dsiInspection';
import { DsiSessionStatus } from './dsiSession';
import { z } from 'zod';

export const DsiSessionTracking = z.object({
    lockedOn: z.coerce.date().nullish(),
    lockedBy: z.string().nullish(),
    status: DsiSessionStatus.nullish(),
    statusDetails: z.string().array().nullish(),
    labelCount: z.number().nullish(),
    isFullyAnnotated: z.boolean().nullish(),
    hasManualAnnotations: z.boolean().nullish(),
    wasInspected: z.boolean().nullish(),
    inspectionResult: DsiInspectionResult.nullish(),
    wasConfirmed: z.boolean().nullish(),
    inspectionConfirmResult: DsiInspectionConfirmationResult.nullish(),
    additionalImageClassifications: z.record(z.string(), DsiAdditionalClassificationsTracking).nullish(),
    additionalModelIds: z.string().array().nullish(),
});
export type DsiSessionTracking = z.infer<typeof DsiSessionTracking>;
